var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c",
    "data-name": "Layer 20",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260.0889 213.5914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "d",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    "data-name": "Path 10476",
    d: "m152.7919,126.3484c.0048,12.1111-9.8095,21.9326-21.9202,21.9374-3.4375.0008-6.8266-.8059-9.8948-2.3552,5.3225-1.8246,8.1582-7.6184,6.3336-12.9401-1.8242-5.3225-7.618-8.1586-12.9405-6.334-1.9962.6842-3.7308,1.9718-4.964,3.6844-.032.04-.0584.084-.0788.1312-.2617-1.3588-.3909-2.7401-.3869-4.1237-.2065-12.1095,9.4422-22.0935,21.5513-22.2999,12.1095-.2065,22.0935,9.4422,22.2999,21.5517.0044.2497.0044.4986,0,.7482h.0004Z",
    fill: "#1f3664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    "data-name": "Path 10477",
    d: "m251.2716,124.3026c-18.6116-40.5402-66.9731-67.7337-120.4086-67.7337h-.2425c-53.3111.0784-101.6134,27.3047-120.1529,67.7337l-.9439,2.0254.9439,2.0254c18.6052,40.5402,66.9731,67.7337,120.415,67.7337h.2425c53.2979-.0848,101.6134-27.3047,120.1529-67.7337l.9375-2.0254-.9439-2.0254Zm-120.1661,62.0559h-.2425c-48.768,0-92.8682-24.0133-110.5946-60.024,17.7005-35.9187,61.6958-59.9456,110.3718-60.0304h.2293c48.7808,0,92.8614,24.0133,110.5946,60.0304-17.6869,35.9195-61.689,59.9464-110.3586,60.0248v-.0008Z",
    fill: "#1f3664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    "data-name": "Path 10478",
    d: "m130.8631,75.1938c-28.2406,0-51.1344,22.8937-51.1344,51.1348-.0004,28.2402,22.8933,51.134,51.1344,51.134s51.1344-22.8929,51.1344-51.134c-.0252-28.2306-22.9041-51.1092-51.1344-51.1348Zm0,92.5401c-22.8677.004-41.4089-18.5315-41.4125-41.3989-.0036-22.8681,18.5315-41.4093,41.3993-41.4125,22.8677-.004,41.4089,18.5315,41.4125,41.3989v.0064c-.0176,22.8585-18.5411,41.3853-41.3993,41.4069v-.0008Z",
    fill: "#1f3664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    "data-name": "Path 10479",
    d: "m41.5087,71.1102c-1.6189.0024-3.133-.8019-4.0385-2.1439l-12.0231-17.7793c-1.4233-2.2831-.7262-5.2873,1.5565-6.7102,2.1635-1.3492,5.0008-.8011,6.5069,1.2556l12.0231,17.7793c1.5061,2.2247.9235,5.2489-1.3012,6.755-.8043.5442-1.753.8355-2.7241.8363l.0004.0072Z",
    fill: "#1f3664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    "data-name": "Path 10480",
    d: "m69.3115,56.471c-1.9098-.0016-3.6428-1.1196-4.4318-2.8585l-9.5387-20.9779c-1.1116-2.4472-.0284-5.3329,2.4192-6.4445,2.4472-1.1116,5.3325-.028,6.4441,2.4192l9.5387,20.9779c1.1116,2.4496.0272,5.3369-2.4228,6.4485-.631.2865-1.316.4345-2.009.4353h.0004Z",
    fill: "#1f3664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    "data-name": "Path 10481",
    d: "m100.9101,47.3716c-2.3071-.0056-4.2938-1.6285-4.7595-3.8876l-4.8972-23.7844c-.5434-2.632,1.1504-5.2065,3.7824-5.749,2.632-.5434,5.2061,1.15,5.7494,3.782l4.8972,23.7844c.5402,2.6312-1.1524,5.2041-3.7828,5.749-.3253.068-.657.1032-.9895.1056Z",
    fill: "#1f3664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    "data-name": "Path 10482",
    d: "m130.8629,44.677c-2.6865.0032-4.8672-2.1711-4.8708-4.8576V14.3897c0-2.6881,2.1791-4.8672,4.8676-4.8672s4.8676,2.1791,4.8676,4.8672v25.4233c-.0004,2.6865-2.1779,4.864-4.8644,4.864Z",
    fill: "#1f3664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    "data-name": "Path 10483",
    d: "m220.2237,71.1033c-2.6901-.008-4.864-2.1959-4.8556-4.8864.0028-.9635.2917-1.9054.8303-2.7049l12.0231-17.7793c1.5061-2.2263,4.5323-2.8105,6.759-1.3044s2.8105,4.5327,1.3044,6.759h0l-12.0231,17.7793c-.9071,1.3396-2.4204,2.1399-4.0381,2.1367Z",
    fill: "#1f3664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    "data-name": "Path 10484",
    d: "m192.4147,56.471c-2.6901-.0056-4.8664-2.1911-4.8604-4.8816.0016-.6906.15-1.3732.4353-2.0022l9.5387-20.9779c1.1116-2.4472,3.9969-3.5307,6.4441-2.4192,2.4476,1.1116,3.5307,3.9973,2.4192,6.4445h0l-9.5387,20.9779c-.7899,1.7414-2.526,2.8593-4.4382,2.8585Z",
    fill: "#1f3664"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    "data-name": "Path 10485",
    d: "m160.8162,47.3721c-.3325-.0016-.6642-.0368-.9899-.1048-2.6304-.545-4.323-3.1178-3.7828-5.749l4.8972-23.7844c.5434-2.632,3.1174-4.3254,5.7494-3.782,2.632.5426,4.3258,3.117,3.7824,5.749l-4.8972,23.7844c-.4661,2.2591-2.4524,3.8812-4.7591,3.8868Z",
    fill: "#1f3664"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/Icon_Eye.407e9e092a77bf8d01baca36d458d8a6.svg";
export { ForwardRef as ReactComponent };